export interface Preferences { textScale: number; shake: boolean }

export function parsePreferences(value: unknown): Preferences {
  const v = value as Partial<Preferences> | null;
  return { textScale: [1, 1.15, 1.3].includes(v?.textScale ?? 0) ? v!.textScale! : 1, shake: typeof v?.shake === 'boolean' ? v.shake : true };
}

function load(): Preferences {
  try { return parsePreferences(JSON.parse(localStorage.getItem('ww.preferences') ?? 'null')); } catch { return parsePreferences(null); }
}

export const preferences = load();
export function applyPreferences(): void {
  document.documentElement.style.setProperty('--text-scale', String(preferences.textScale));
  document.documentElement.dataset.motion = preferences.shake ? 'full' : 'reduced';
}
export function savePreferences(): void {
  applyPreferences();
  try { localStorage.setItem('ww.preferences', JSON.stringify(preferences)); } catch { /* storage unavailable */ }
}
